// extracted by mini-css-extract-plugin
export default {"app":"App_app__2x0g9","board":"App_board__oi+1u","popup":"App_popup__mZml4"};